import { RiskRating } from "../../../graphql/supergraphTypes";

export enum AmlKycDisplayStatus {
  Compliant = "Compliant",
  InReview = "Juniper Square review",
  Submission = "LP submission",
  NotStarted = "Review not started",
  Divestment = "Pending divestment",
}

export type TableFilters = {
  entityName: string;
};

export type EntityRowData = {
  entityId: string;
  entityName: string;
  totalPositions: number;
  compliant: number;
  reviewNotStarted: number;
  inJSQReview: number;
  inLPSubmission: number;
  pendingDivestment: number;
  lastActivity: string | null;
};

export type PositionRowData = {
  positionId: number;
  investorName: string;
  entityName: string | null;
  complianceStatus: AmlKycDisplayStatus;
  riskRating: RiskRating;
  screeningStatus: string;
  onboardingDate: string | null;
  lastActivity: string | null;
};
